import Icon from '../../../components/AppIcon';
import { CONTACT } from 'config/contact';
import { TrustSignal } from '../types';

interface TrustSignalsProps {
  signals: TrustSignal[];
}

const TrustSignals = ({ signals }: TrustSignalsProps) => {
  return (
    <section className="py-16 bg-background">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl sm:text-4xl font-bold text-brand-primary mb-4">
            Your Information is Safe With Us
          </h2>
          <p className="text-lg text-text-secondary max-w-2xl mx-auto">
            We take data security and privacy seriously. Your trust is our top priority.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {signals.map((signal) => (
            <div
              key={signal.id}
              className="bg-card border border-border rounded-xl p-6 text-center hover:shadow-lg transition-shadow duration-fast"
            >
              <div className="w-16 h-16 bg-success/10 rounded-full flex items-center justify-center mx-auto mb-4">
                <Icon name={signal.icon} size={32} className="text-success" />
              </div>
              
              <h3 className="text-lg font-semibold text-brand-primary mb-2">
                {signal.title}
              </h3>
              
              <p className="text-sm text-text-secondary">
                {signal.description}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-12 bg-gradient-to-r from-primary/10 to-accent/10 rounded-2xl p-8">
          <div className="flex flex-col md:flex-row items-center justify-between gap-6">
            <div className="flex-1">
              <h3 className="text-xl font-semibold text-brand-primary mb-2">
                Questions About Our Process?
              </h3>
              <p className="text-text-secondary">
                We're here to help. Reach out via WhatsApp for instant answers or check our FAQ section below.
              </p>
            </div>
            
            <a
              href={CONTACT.whatsappLink}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center space-x-2 bg-success text-success-foreground px-6 py-3 rounded-lg font-semibold hover:bg-success/90 transition-colors duration-fast whitespace-nowrap"
            >
              <Icon name="MessageCircle" size={20} />
              <span>Chat on WhatsApp</span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrustSignals;